@if (isShow) {
  <div class="gallery" (click)="onClose()" [class.loading]="isLoading" [class.is-show]="isShow">
    <div class="gallery-inner" #gallery_inner>
      <div class="gallery-content">
        <p class="gallery-caption gallery-file-name" #gallery_title>
          {{ currentItem.file_name }}
        </p>
        @if (currentItem.isImage()) {
          <img
            class="gallery-img"
            #gallery_content
            (click)="preventCloseOnContent($event)"
            (load)="onContentLoad()"
            [src]="currentItem.previewLink()"
          />
        }
        @if (currentItem.isVideo()) {
          <video
            class="gallery-video"
            #gallery_content
            controls
            autoplay
            (click)="preventCloseOnContent($event)"
            (loadeddata)="onContentLoad()"
            [src]="currentItem.previewLink()"
          ></video>
        }
        @if (currentItem.isAudio()) {
          <audio
            class="gallery-audio"
            #gallery_content
            controls
            autoplay
            (click)="preventCloseOnContent($event)"
            (loadeddata)="onContentLoad()"
            [src]="currentItem.previewLink()"
          ></audio>
        }
        <p class="gallery-caption" #gallery_caption>
          {{ currentItem.caption }}
        </p>
      </div>
      @if (isLoading) {
        <div class="gallery-loader"></div>
      }
      @if (canNavigate()) {
        <button class="previous-button gallery-button" (click)="onPrevious($event)"></button>
      }
      @if (canNavigate()) {
        <button class="next-button gallery-button" (click)="onNext($event)"></button>
      }
    </div>
  </div>
}
